<app-spinner *ngIf="loadingZones"></app-spinner>

<div *ngIf="zones && meta.totalItems > 0">
  <form name="form" novalidate>
    <div class="form-group">
      <div class="input-group">
        <span class="input-group-addon">
          <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
        </span>
        <app-search-text-input
          [field]="'by_name'"
          [value]="filterCriteria.by_name"
          [pattern]="'text'"
          [placeHolder]="'NAME'"
          (searched)="onSearched($event)"
        >
        </app-search-text-input>
      </div>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
            >
              {{ 'NAME' | translate }}
            </app-sort-by>
          </th>
          <th>{{ 'LOCATIONS_INCLUDED' | translate }}</th>
          <th class="align-center">{{ 'PICKUP_PLACES' | translate }}</th>
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadZones()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let zone of zones" id="{{ zone.id }}">
          <!-- Name -->
          <td
            (click)="selectZone(zone)"
            [ngClass]="utilService.checkItemStatus(zone.status)"
            class="cursor"
          >
            {{ zone.name }}
          </td>

          <!-- Locations -->
          <td
            (click)="selectZone(zone)"
            [ngClass]="utilService.checkItemStatus(zone.status)"
            class="cursor"
          >
            <span *ngFor="let location of zone.locations">
              <span class="label label-default">{{ location.name }}</span
              >&nbsp;
            </span>
          </td>

          <!-- Total Pickup places -->
          <td
            (click)="selectZone(zone)"
            [ngClass]="utilService.checkItemStatus(zone.status)"
            class="cursor"
          >
            <span class="label label-info">{{ zone.totalPickupPlaces }}</span>
          </td>

          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <li *ngIf="permissions.canShow">
                  <a class="cursor" (click)="selectZone(zone, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>
                <li *ngIf="permissions.canUpdate">
                  <a class="cursor" (click)="changeZoneStatus(zone)">
                    <i
                      [ngClass]="
                        zone.status === 'active' ? 'fa fa-minus-square' : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      zone.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>
                <li *ngIf="permissions.canDestroy" class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a class="cursor" (click)="deleteZone(zone)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a (click)="clearSearchForm()" class="cursor">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="zones && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
